module.exports = __webpack_public_path__ + "assets/img/4.f873d7ba.png";